var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgZoominfo = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 27,
    fill: "none",
    viewBox: "0 0 26 27",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#22262A",
    strokeWidth: 1.339,
    d: "M13.25 25.375c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#22262A",
    fillRule: "evenodd",
    d: "M18.202 18.078h-5.397c-.123 0-.224.1-.224.222v.877a.223.223 0 0 0 .221.225h6.514a.22.22 0 0 0 .224-.221v-3.104c0-.122-.1-.221-.223-.222h-.89c-.124 0-.225.1-.225.222zM8.075 8.144h5.967a.22.22 0 0 0 .225-.22V7.08a.22.22 0 0 0-.225-.219h-7.08a.22.22 0 0 0-.224.219v3.014c0 .122.1.222.224.222h.889c.123 0 .224-.1.224-.222zM16.171 6.861h3.141c.124 0 .224.1.224.221v2.972c0 .122-.1.221-.224.221h-.889a.22.22 0 0 1-.224-.22v-.916l-9.47 8.942h1.948c.123 0 .224.1.224.222v.877c0 .123-.1.222-.224.222H6.963a.223.223 0 0 1-.225-.222v-1.095L17.235 8.18h-1.064a.223.223 0 0 1-.224-.222V7.08a.22.22 0 0 1 .224-.219",
    clipRule: "evenodd"
  })));
};
export default SvgZoominfo;